import { render } from "./shared.vue?vue&type=template&id=06ab53d6"
import script from "./shared.vue?vue&type=script&lang=js"
export * from "./shared.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__